import React from 'react';
import { MessageCircle } from 'lucide-react';
import { STAGES, PRIORITIES } from './api';

// "Compact Ledger" list — dense, scannable, zebra rows, tabular values.
const stage = (k) => STAGES.find((s) => s.key === k) || { label: k, color: '#94a3b8' };
const prio = (p) => PRIORITIES.find((x) => x.key === p) || PRIORITIES[1];
const inr = (v) => (v ? '₹' + Number(v).toLocaleString('en-IN') : '—');

export default function LeadLedger({ leads, onOpen, onWhatsApp }) {
  return (
    <div className="bg-[var(--card)] border border-[var(--border)] rounded-2xl card-lux overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full text-[13.5px]" style={{ minWidth: 660 }}>
          <thead>
            <tr className="bg-[var(--soft)] text-[var(--muted)]" style={{ fontSize: 10.5 }}>
              {['Lead', 'Interest', 'Stage', 'Priority', 'Source', 'Value'].map((h) => (
                <th key={h} className="text-left px-4 py-2.5 font-bold uppercase tracking-wide" style={{ textAlign: h === 'Value' ? 'right' : 'left' }}>{h}</th>
              ))}
              {onWhatsApp && <th className="px-3 py-2.5" />}
            </tr>
          </thead>
          <tbody>
            {leads.map((l, i) => {
              const s = stage(l.status); const p = prio(l.priority);
              return (
                <tr key={l.id} onClick={() => onOpen(l.id)} className="cursor-pointer border-t border-[var(--border)] hover:brightness-95"
                  style={{ background: i % 2 ? 'var(--soft)' : 'transparent' }}>
                  <td className="px-4 py-2.5">
                    <div className="font-bold text-[var(--text)] flex items-center gap-1.5">{l.priority === 'hot' && '🔥'}{l.name || '(no name)'}</div>
                    <div className="text-[11.5px] text-[var(--muted)]">{l.company || '—'}</div>
                    {l.Campaign?.name && <div className="mt-0.5"><span className="text-[10px] font-bold px-1.5 py-0.5 rounded-full whitespace-nowrap" style={{ color: '#0e7490', background: '#0e749018' }}>🎪 {l.Campaign.name}</span></div>}
                  </td>
                  <td className="px-4 py-2.5 text-[var(--muted)]">{l.interest || '—'}</td>
                  <td className="px-4 py-2.5"><span className="text-[11px] font-extrabold text-white px-2 py-0.5 rounded-full" style={{ background: s.color }}>{s.label}</span></td>
                  <td className="px-4 py-2.5"><span className="inline-flex items-center gap-1.5 font-bold" style={{ color: p.color, fontSize: 12 }}><span className="w-2 h-2 rounded-full" style={{ background: p.color }} />{p.label}</span></td>
                  <td className="px-4 py-2.5 text-[var(--muted)] text-[11px] font-bold uppercase">{l.source}</td>
                  <td className="px-4 py-2.5 text-right font-extrabold text-[var(--text)]" style={{ fontVariantNumeric: 'tabular-nums', color: l.value ? 'var(--text)' : 'var(--muted)' }}>{inr(l.value)}</td>
                  {onWhatsApp && (
                    <td className="px-3 py-2.5">
                      {l.phone && <button onClick={(e) => { e.stopPropagation(); onWhatsApp(l.phone); }}
                        className="w-7 h-7 rounded-lg flex items-center justify-center text-emerald-600 bg-emerald-50 hover:bg-emerald-100" title="WhatsApp"><MessageCircle size={15} /></button>}
                    </td>
                  )}
                </tr>
              );
            })}
            {leads.length === 0 && <tr><td colSpan={7} className="px-4 py-10 text-center text-[var(--muted)]">No leads.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
